import { defineMessages } from 'react-intl';

const messages = defineMessages({
  templatesHeader: {
    id: 'Templates.shared.templatesHeader',
    defaultMessage: 'Templates',
    description: 'Templates Header',
  },
  templatesSubheader: {
    id: 'Templates.shared.templatesSubheader',
    defaultMessage:
      'Create, edit, and save your Checklist, Report, Document, and Project templates.',
    description: 'Templates Subheader',
  },
  templateNameHeader: {
    id: 'Templates.shared.templateNameHeader',
    defaultMessage: 'Template Name',
    description: 'Template Name Header',
  },
  lastUpdatedHeader: {
    id: 'Templates.shared.lastUpdatedHeader',
    defaultMessage: 'Last Updated',
    description: 'Date time template was last updated',
  },
  onboardModalDescription: {
    id: 'Templates.shared.onboardModalDescription',
    defaultMessage:
      'Create, edit, and save your Checklist and Report templates in one spot, all without having to go into a project.',
    description: 'Description for templates onboard modal',
  },
  onboardModalBtnLabel: {
    id: 'Templates.shared.onboardModalBtnLabel',
    defaultMessage: `Let's Go`,
    description: 'Label for onboard modal confirm button',
  },
  createChecklist: {
    id: 'Templates.shared.createChecklistTemplate',
    defaultMessage: 'Create Checklist Template',
    description: 'Label for button to create new checklist template',
  },
  createChecklistErrorMsg: {
    id: 'Template.shared.createChecklistErrorMsg',
    defaultMessage:
      'Something went wrong while creating a checklist template. Please try again.',
    description: 'Error message for create checklist template error',
  },
  emptyChecklistTemplatesMsg: {
    id: 'Template.shared.emptyChecklistTemplatesMsg',
    defaultMessage: 'Streamline your projects with Checklist Templates',
  },
  deleteTemplateButtonLabel: {
    id: 'Template.shared.deleteTemplateButtonLabel',
    defaultMessage: 'Delete',
  },
  deleteChecklistTitle: {
    id: 'Template.shared.deleteChecklistTitle',
    defaultMessage: 'Delete Checklist Template',
  },
  deleteChecklistTemplateMsg: {
    defaultMessage:
      "Are you sure you want to delete this template? This won't affect any checklists you've already created with this template.",
    description: 'Confirmation message for deleting checklist template',
    id: 'Template.shared.deleteChecklistTemplateMsg',
  },
  deleteReportTemplateMsg: {
    defaultMessage:
      "Are you sure you want to delete this template? This won't affect any reports you've already created with this template.",
    description: 'Confirmation message for deleting report template',
    id: 'Template.shared.deleteReportTemplateMsg',
  },
  createReportErrorMsg: {
    id: 'Template.shared.createReportErrorMsg',
    defaultMessage:
      'Something went wrong while creating a report template. Please try again.',
    description: 'Error message for create report template error',
  },
  editingReportTemplateDisclaimer: {
    id: 'Templates.shared.editingReportTemplateDisclaimer',
    defaultMessage:
      'You’re currently editing a template. Any changes you make will not affect previously created reports.',
    description:
      'disclaimer warning message to caution user this is a template',
  },
  createReport: {
    id: 'Templates.shared.createReport',
    defaultMessage: 'Create Report Template',
    description: 'Label for button to create new report template',
  },
  deleteReportTitle: {
    id: 'Template.shared.deleteReportTitle',
    defaultMessage: 'Delete Report Template',
    description: 'Headline for deleting a report template',
  },
  emptyReportTemplatesMsg: {
    id: 'Template.shared.emptyReportTemplatesMsg',
    defaultMessage: 'Streamline your projects with Report Templates',
    description:
      'Message for users when viewing an empty reports template list',
  },
  editingReportTemplateError: {
    id: 'Template.shared.editingReportTemplateError',
    defaultMessage: 'There was an error updating the report template',
    description:
      'Message for users when there was an error updating report template',
  },
  genericEditTemplateError: {
    id: 'Template.shared.genericEditTemplateError',
    defaultMessage: 'There was an error saving the template',
    description:
      'Generic message for users when there was an error saving a template',
  },
  templateCreatedError: {
    id: 'Template.shared.templateCreatedError',
    defaultMessage:
      'Something went wrong while creating a template. Please try again.',
    description: 'Error message when user creates a template',
  },
  templateDeletedSuccess: {
    id: 'Template.shared.templateDeletedSuccess',
    defaultMessage: 'Template Deleted',
    description: 'Success message when user deletes a template',
  },
  templateDeletedError: {
    id: 'Template.shared.templateDeletedError',
    defaultMessage: 'There was an error deleting this template',
    description: 'Error message when user deletes a report template',
  },
  createProject: {
    id: 'Templates.shared.createProject',
    defaultMessage: 'Create Project Template',
    description: 'Label for button to create new project template',
  },
  emptyProjectTemplatesMsg: {
    id: 'Template.shared.emptyProjectTemplatesMsg',
    defaultMessage: 'Streamline your projects with Project Templates',
    description:
      'Message for users when viewing an empty project template list',
  },
  addTemplates: {
    id: 'Template.shared.addTemplates',
    defaultMessage: 'Add to Project Template',
    description: 'Label for Add Template button',
  },
  manageDocuments: {
    id: 'Template.shared.manageDocuments',
    defaultMessage: 'Manage Documents',
    description: 'Label for Manage Documents button',
  },
  clearSelection: {
    id: 'Template.shared.clearSelection',
    defaultMessage: 'Clear Selection',
    description: 'Label for Clear Selection button',
  },
  goToTemplates: {
    id: 'Template.shared.goToTemplates',
    defaultMessage: 'Go to Templates',
    description: 'Label for button',
  },
  defaultEmptyStateMessage: {
    id: 'Template.shared.defaultEmptyStateMsg',
    defaultMessage: 'Create a new template in the Templates page',
    description: 'Default message for empty state',
  },
  projectTemplatesTooltip: {
    id: 'Template.shared.projectTemplatesTooltip',
    defaultMessage: 'Manage Project Templates Here',
    description: 'Onboarding tooltip message for project templates',
  },
  templateTitlePlaceholder: {
    id: 'Templates.shared.templateTitlePlaceholder',
    defaultMessage: 'Enter Template Title',
    description: 'placeholder text for template title',
  },
  templateDescriptionPlaceholder: {
    id: 'Templates.shared.templateDescriptionPlaceholder',
    defaultMessage: 'Enter Template Description',
    description: 'placeholder text for template description',
  },
  checklists: {
    id: 'Templates.shared.checklists',
    defaultMessage: 'Checklists',
    description: 'Checklists',
  },
  reports: {
    id: 'Templates.shared.reports',
    defaultMessage: 'Reports',
    description: 'Reports',
  },
  companyDocuments: {
    id: 'Templates.shared.companyDocuments',
    defaultMessage: 'Project Documents',
    description: 'Project Documents',
  },
  pages: {
    id: 'Templates.shared.pages',
    defaultMessage: 'Pages',
    description: 'Pages',
  },
  addChecklists: {
    id: 'Templates.shared.addChecklists',
    defaultMessage: 'Add Checklists',
    description: 'Button label for adding checklists to templates',
  },
  emptyMultiSelectModal: {
    id: 'Templates.shared.multiSelectModal.empty',
    defaultMessage: 'No Templates Found',
    description: 'Empty message for multiselect modal',
  },
  addReports: {
    id: 'Templates.shared.addReports',
    defaultMessage: 'Add Reports',
    description: 'Button label for adding reports to templates',
  },
  checklistModalHeader: {
    id: 'Templates.shared.checklistModalHeader',
    defaultMessage: 'Add Checklists',
    description: 'Header title for checklist modal',
  },
  reportModalHeader: {
    id: 'Templates.shared.reportModalHeader',
    defaultMessage: 'Add Reports',
    description: 'Header title for checklist modal',
  },
  projectTemplateTaskListEmptyState: {
    id: 'Templates.shared.projectTemplateTaskListEmptyState',
    defaultMessage:
      "You've added all of your available checklist templates to this project template.",
    description:
      'Empty state message for adding checklists to a project template',
  },
  projectTemplateReportEmptyState: {
    id: 'Templates.shared.projectTemplateReportEmptyState',
    defaultMessage:
      "You've added all of your available report templates to this project template.",
    description:
      'Empty state message for adding reports to a project teemplate',
  },
  projectTemplateCompanyDocumentEmptyState: {
    id: 'Templates.shared.projectTemplateCompanyDocumentEmptyState',
    defaultMessage:
      "You've added all of your available project documents to this project template.",
    description:
      'Empty state message for project documents to a project template',
  },
  deleteProjectTemplateTitle: {
    id: 'Templates.shared.deleteProjectTemplate.title',
    defaultMessage: 'Delete Template',
    description: 'Header title for delete project template modal',
  },
  deleteProjectTemplateMessage: {
    id: 'Templates.shared.deleteProjectTemplate.message',
    defaultMessage:
      'Are you sure you want to delete this template? Deleting this project template will not delete the individual templates contained within it.',
    description: 'Message for delete project template modal',
  },
  deleteTemplateSuccessToast: {
    id: 'Templates.shared.deleteTemplateSuccess',
    defaultMessage: 'The template was succesfully deleted',
    description: 'Success message for deleting template',
  },
  deleteTemplateErrorToast: {
    id: 'Templates.shared.deleteTemplateError',
    defaultMessage:
      'Something went wrong while deleting your template. Please try again.',
    description: 'Error message for deleting template',
  },
  setDefaultProjectTemplate: {
    id: 'Templates.shared.setDefaultProjectTemplate',
    defaultMessage: 'Set as Default Template',
    description: 'Menu option in project template for setting default template',
  },
  unsetDefaultProjectTemplate: {
    id: 'Templates.shared.unsetDefaultProjectTemplate',
    defaultMessage: 'Remove as Default Template',
    description:
      'Menu option in project template for removing default template',
  },
  setDefaultProjectTemplateConfirm: {
    id: 'Templates.shared.setDefaultProjectTemplateConfirm',
    defaultMessage: 'Set default template',
    description: 'Modal confirm option when setting a default project template',
  },
  setDefaultProjectTemplateCancel: {
    id: 'Templates.shared.setDefaultProjectTemplateCancel',
    defaultMessage: "No, don't set",
    description: 'Modal cancel option when setting a default project template',
  },
  unsetDefaultProjectTemplateConfirm: {
    id: 'Templates.shared.unsetDefaultProjectTemplateConfirm',
    defaultMessage: 'Remove default template',
    description:
      'Modal confirm option when removing a default project template',
  },
  unsetDefaultProjectTemplateCancel: {
    id: 'Templates.shared.unsetDefaultProjectTemplateCancel',
    defaultMessage: "No, don't remove",
    description: 'Modal cancel option when setting a default project template',
  },
  defaultProjectTemplateTooltip: {
    id: 'Templates.shared.defaultProjectTemplateTooltip',
    defaultMessage:
      'Set a default project template to automatically be pre-selected on any new project, including ones created through integrations.',
    description:
      'Tooltip message for users informing them of new default project templates',
  },
  setDefaultProjectTemplateTitle: {
    id: 'Templates.shared.setDefaultProjectTemplateTitle',
    defaultMessage: 'Set Default Template',
    description: 'Modal header for setting a template as default',
  },
  setDefaultProjectTemplateMessage: {
    id: 'Templates.shared.setDefaultProjectTemplateMessage',
    defaultMessage:
      'Are you sure you want to use this as a default template? Any project created through an integration will automatically apply this template',
    description: 'Modal body for setting a template as default',
  },
  succcessSetDefaultProjectTemplate: {
    id: 'Templates.shared.succcessSetDefaultProjectTemplate',
    defaultMessage: 'Successfully set default template',
    description:
      'Message after successfully setting a default project template',
  },
  errorSetDefaultProjectTemplate: {
    id: 'Templates.shared.errorSetDefaultProjectTemplate',
    defaultMessage: 'There was an error setting this default template',
    description:
      'Error message after unsuccessfully setting a default project template',
  },
  unsetDefaultProjectTemplateTitle: {
    id: 'Templates.shared.unsetDefaultProjectTemplateTitle',
    defaultMessage: 'Remove Default Template',
    description: 'Modal header for setting a template as default',
  },
  unsetDefaultProjectTemplateMessage: {
    id: 'Templates.shared.unsetDefaultProjectTemplateMessage',
    defaultMessage:
      'Are you sure you want to remove this as a default template? Projects created through integrations will not have a template automatically applied',
    description: 'Modal body for setting a template as default',
  },
  succcesUnsetRemoveDefaultProjectTemplate: {
    id: 'Templates.shared.succcesUnsetRemoveDefaultProjectTemplate',
    defaultMessage: 'Successfully removed default template',
    description:
      'Success message after successfully removing a default project template',
  },
  errorUnsetRemoveDefaultProjectTemplate: {
    id: 'Templates.shared.errorUnsetRemoveDefaultProjectTemplate',
    defaultMessage: 'There was an error removing this default template',
    description:
      'Error message after unsuccessfully removing a default project template',
  },
  defaultTemplate: {
    id: 'Templates.shared.defaultTemplateBadge',
    defaultMessage: 'Default Template',
    description: 'Default Template Badge',
  },
  addDocument: {
    id: 'Templates.shared.addDocumentButton',
    defaultMessage: 'Add Document',
    description: 'Add Document button',
  },
  addDocuments: {
    id: 'Templates.shared.addsDocuments',
    defaultMessage: 'Add Documents',
    description: 'Add Documents button',
  },
  fileTypeHeader: {
    id: 'Templates.shared.documentFileTypeColumn',
    defaultMessage: 'File Type',
    description: 'File Type Column Header for Project Documents',
  },
  emptyCompanyDocumentMsg: {
    id: 'Template.shared.emptyCompanyDocumentMsg',
    defaultMessage: 'Streamline your projects with Project Documents',
    description:
      'Message for users when viewing an empty project documents list',
  },
  deleteDocumentTitle: {
    id: 'CompanyDocument.delete.title',
    defaultMessage: 'Delete Project Document',
    description: 'Headline for deleting a project document',
  },
  deleteDocumentConfirmationMsg: {
    id: 'CompanyDocument.delete.confirmationMsg',
    defaultMessage:
      'Are you sure you want to delete this Project Document? It will be removed if used on a Project Template, but not from any existing projects',
    description: 'Confirmation prompt for deleting project document',
  },
  createPage: {
    id: 'Templates.shared.createPage',
    defaultMessage: 'Create Page Template',
    description: 'Label for button to create new page template',
  },
  projectTemplatePageEmptyState: {
    id: 'Templates.shared.projectTemplatePageEmptyState',
    defaultMessage:
      "You've added all of your available page templates to this project template.",
    description: 'Empty state message for adding pages to a project template',
  },
  deletePageTitle: {
    id: 'Templates.shared.deletePageTitle',
    defaultMessage: 'Delete Page Template',
    description: 'Headline for deleting a page template',
  },
  deletePageTemplateMsg: {
    id: 'Templates.shared.deletePageTemplateMsg',
    defaultMessage:
      'Are you sure you want to delete this Page Template? This will not affect any pages you’ve already created with this template.',
    description: 'Confirmation prompt for deleting page template',
  },
  emptyPageTemplatesMsg: {
    id: 'Templates.shared.emptyPageTemplatesMsg',
    defaultMessage: 'Streamline your projects with Page Templates',
    description: 'Message for users when viewing an empty page template list',
  },
  addPages: {
    id: 'Templates.shared.addPages',
    defaultMessage: 'Add Pages',
    description: 'Add Pages button',
  },
  managePageTemplates: {
    id: 'Templates.shared.managePageTemplates',
    defaultMessage: 'Manage Page Templates',
    description: 'Manage Page Templates button',
  },
  manageReportTemplates: {
    id: 'Templates.shared.manageReportTemplates',
    defaultMessage: 'Manage Report Templates',
    description: 'Manage Report Templates button',
  },
  manageTaskListTemplates: {
    id: 'Templates.shared.manageTaskListTemplates',
    defaultMessage: 'Manage Checklist Templates',
    description: 'Manage Checklist Templates button',
  },
});

export default messages;
